import { RootState } from 'editor/src/store/index';

const getFlatPreviews = (state: RootState) =>
  state.editorModules.preview.flatPreviews.filter((preview) => !preview.loadingFailed);

export default getFlatPreviews;
